export default "__VITE_ASSET__ab71e863__"